import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import List from './components/List'
import Create from './components/Create'
import Update from './components/Update'

const JobCategoryModule: RouteObject = {
    path: 'job-categories',
    children: [
        {
            path: '',
            children: [
                {
                    path: '',
                    element: <List />,
                },
                {
                    path: 'new',
                    element: <Create />,
                },
                {
                    path: ':jobCategoryID',
                    children: [
                        {
                            path: '',
                            element: <Update />,
                        },
                    ],
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default JobCategoryModule
